// Owner: web shell. Collects every module's routes, page overrides and sidebar entries (contract: ./README.md).
// Module lanes never edit this file: they edit only their own folder's index.ts. A new module folder needs one
// import line here; ask the web shell owner (or the manager) to add it.
import { mergeModules, type WebModule } from '../lib/modules'
import { module as accessReviews } from './access-reviews'
import { module as assets } from './assets'
import { module as audits } from './audits'
import { module as connections } from './connections'
import { module as controls } from './controls'
import { module as dashboard } from './dashboard'
import { module as devices } from './devices'
import { module as events } from './events'
import { module as evidence } from './evidence'
import { module as frameworks } from './frameworks'
import { module as maintenance } from './maintenance'
import { module as monitoring } from './monitoring'
import { module as notifications } from './notifications'
import { module as parallel } from './parallel'
import { module as personnel } from './personnel'
import { module as policies } from './policies'
import { module as remediation } from './remediation'
import { module as risks } from './risks'
import { module as settings } from './settings'
import { module as tasks } from './tasks'
import { module as trust } from './trust'
import { module as vendors } from './vendors'
import { module as vulnerabilities } from './vulnerabilities'

/** Every web module, keyed by folder name (the same name as the server module). */
export const MODULES: Record<string, WebModule> = {
  'access-reviews': accessReviews,
  assets,
  audits,
  connections,
  controls,
  dashboard,
  devices,
  events,
  evidence,
  frameworks,
  maintenance,
  monitoring,
  notifications,
  parallel,
  personnel,
  policies,
  remediation,
  risks,
  settings,
  tasks,
  trust,
  vendors,
  vulnerabilities,
}

export const webModules = mergeModules(MODULES)

if (webModules.problems.length && import.meta.env.DEV) {
  for (const p of webModules.problems) console.warn(`[web modules] ${p}`)
}
